import { useFeatureFlag } from '@/common/presentation/hooks';
import { FEATURE_FLAGS } from '@/common/domain/constants/featureFlags';
import { CreateMultiDayJobRequest, RaptorJobFormSubmitInput } from '@/raptorjob/domain/raptor-jobs-types';
import { postCreateMultiDayJob } from '@/raptorjob/infrastructure/rest/createMultiDayJob';
import { useMutation } from '@tanstack/react-query';
import { useMapRaptorJobPayload } from '@/raptorjob/application/adapters/useMapRaptorJobPayload';

export const useCreateRaptorMultiDayJob = () => {
  const useMock = useFeatureFlag<boolean>(FEATURE_FLAGS.RAPTOR_JOBS_CREATE_MULTI_DAY_JOB_MOCK_API_ENABLED);
  const { mapMultiDayPayload } = useMapRaptorJobPayload();

  return useMutation({
    mutationKey: ['raptorJob:createMultiDay'],
    mutationFn: async (values: RaptorJobFormSubmitInput): Promise<CreateMultiDayJobRequest & { id: string }> => {
      const payload = mapMultiDayPayload(values);

      return await postCreateMultiDayJob(payload, { useMock });
    }
  });
};
